import { render, staticRenderFns } from "./StepIndicator.vue?vue&type=template&id=2f3586f1&scoped=true"
import script from "./StepIndicator.vue?vue&type=script&lang=js"
export * from "./StepIndicator.vue?vue&type=script&lang=js"
import style0 from "./StepIndicator.vue?vue&type=style&index=0&id=2f3586f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3586f1",
  null
  
)

export default component.exports